$(document).ready(function($) {

  // Override meta fields.
  $('.meta-content').each(function(content) {
    const $content = $(content);
    $('meta[name="' + $content.attr('data-key') + '"]').text($content.text());
  });

  // Manage images switcher.
  $('.product-laser-other-image img').click(function() {
    const $this = $(this);
    $('.product-laser-other-image.selected').removeClass('selected');
    $this.parent().addClass('selected');
    const $mainImage = $('.product-laser-main-image img');
    for (const imgAttr of ['src', 'alt', 'title']) {
      $mainImage.attr(imgAttr, $this.attr(imgAttr));
    }
  });

  $('#product--collapse--description').collapse();

  $('.filter-tags').each(function(i, tagsContainer) {
    const $tagsContainer = $(tagsContainer);
    let mapTags = {};
    $tagsContainer.find('.tag').each(function(i, tag) {
      const $tag = $(tag);
      mapTags[parseFloat($tag.text())] = $tag;
    });

    $tagsContainer.empty();
    const sortedMapKeys = Object.keys(mapTags).sort((a, b) => a - b);
    for (const tag of sortedMapKeys) {
      $tagsContainer.append(mapTags[tag]);
    }
  });
});

// Set the product name in breadcrumb. Used in Detail.LaserProduct.cshtml
function updateBreadcrumb(name) { // eslint-disable-line no-unused-vars
    $('.breadcrumb li:last-child').text(name);
}
